import React from "react";
import { motion } from "framer-motion";
import aboutus from "../../assets/img/AboutUs/aboutus-2.jpg";
import aboutus1 from "../../assets/img/AboutUs/aboutus-3.jpg";
import aboutus2 from "../../assets/img/AboutUs/aboutus-4.jpg";
import aboutus3 from "../../assets/img/AboutUs/aboutus-5.jpg";
import { Helmet } from "react-helmet";

export default function AboutUs() {
  return (
    <>
      <Helmet>
        <title>About Us | Pak Maid Service</title>
        <meta
          name="description"
          content="Learn more about Pak Maid Service – your trusted partner for professional and affordable home cleaning solutions in Pakistan."
        />
      </Helmet>

      <div className="about-section lightBg" id="about">
        <div className="container">
          <div className="row textCenter headerInfo section-heading">
            <div className="col-12">
              <h2 className="font40 extraBold textCenter">About Us</h2>
            </div>
          </div>

          <div className="row flexSpaceCenter">
            <div className="col-md-6 col-xs-12">
              <div className="about-content padBot">
                <h4 className="font15 semiBold">
                  Trusted & Professional Cleaning
                </h4>
                <h2 className="font30 extraBold">
                  Reliable Maid Services — Anytime, Anywhere
                </h2>
                <p className="font20">
                  We provide expert maid services 24/7 to match your busy
                  lifestyle. Whether you need daily, weekly, bi-weekly, or
                  monthly cleaning — we've got flexible plans tailored just for
                  you. Our professionally trained staff ensures spotless homes,
                  deep cleaning, and regular housekeeping with complete safety
                  and trust. Trusted by families, professionals, and businesses
                  across the region.
                </p>
                <ul className="font15">
                  <li>✔️ Available 24/7 – even on weekends and holidays</li>
                  <li>✔️ One-time, weekly, and monthly cleaning plans</li>
                  <li>✔️ Deep cleaning, kitchen, bathrooms, bedrooms & more</li>
                  <li>✔️ Fully trained & background-verified staff</li>
                  <li>✔️ Easy online booking & instant customer support</li>
                </ul>
                <br />
                <a className="btnPrimary" href="#contact">
                  Book Your Service Now
                </a>
              </div>
            </div>

            <div className="col-md-6 col-xs-12">
              <div className="about-image textCenter">
                <motion.div
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    src={aboutus}
                    loading="lazy"
                    alt="Professional Maid Cleaning"
                    className="radius8 about-img"
                  />
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="darkBgAbout feature-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="row textCenter">
              <div className="col-md-4 col-sm-12 feature-column">
                <div className="feature-box whiteBg radius8 shadow">
                  <img
                    src={aboutus3}
                    alt="Cleaning Tools"
                    className="feature-icon"
                  />
                  <h3 className="font20 semiBold">Full House Cleaning</h3>
                  <p className="font12">
                    Complete cleaning of your kitchen, bathrooms, bedrooms, and
                    common areas.
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-12 feature-column">
                <div className="feature-box whiteBg radius8 shadow">
                  <img
                    src={aboutus2}
                    alt="Flexible Plans"
                    className="feature-icon"
                  />
                  <h3 className="font20 semiBold">Flexible Scheduling</h3>
                  <p className="font12">
                    Choose from daily, weekly, or monthly plans. Easily
                    reschedule via our portal.
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-12 feature-column">
                <div className="feature-box whiteBg radius8 shadow">
                  <img src={aboutus1} alt="Support" className="feature-icon" />
                  <h3 className="font20 semiBold">24/7 Customer Support</h3>
                  <p className="font12">
                    Always available to assist you with bookings, changes, and
                    queries.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Embedded Styles */}
      <style>{`
        .lightBg {
          background: #f9f9f9;
          padding: 60px 0;
        }
        
        .feature-column{
          padding:10px;
        }

        .about-section{
          margin-top:5%
        }

        .headerInfo{
          @media (max-width: 860px) {
            text-align: center !important;
            justify-content: center;
  }
        }

        .padBot{
          padding-bottom: 5px;
        }
         .darkBgAbout {
        background: #2fb8a7;
           padding: 60px 0;
         }

        .textCenter {
          text-align: center;
        }

        .radius8 {
          border-radius: 8px;
        }

        .shadow {
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        .btnPrimary {
          background: #00bfa6;
          color: white;
          padding: 10px 25px;
          text-decoration: none;
          border-radius: 6px;
          font-weight: 600;
          transition: 0.3s ease;
          display: inline-block;
        }

        .btnPrimary:hover {
          background: #009f8b;
        }

        .about-img {
          width: 100%;
          max-height: 400px;
          object-fit: cover;
        }

        .feature-icon {
          width: 100%;
          max-height: 200px;
          object-fit: cover;
          border-radius: 10px;
          margin-bottom: 15px;
        }

        .feature-box {
          padding: 30px;
          text-align: center;
          height: 100%;
        }

        .feature-col {
          margin-bottom: 30px;
        }

        .font12 {
          font-size: 12px;
        }

        .font15 {
          font-size: 15px;
        }

        .font20 {
          font-size: 20px;
        }

        .font40 {
          font-size: 40px;
        }

        .semiBold {
          font-weight: 600;
        }

        .extraBold {
          font-weight: 800;
        }

        @media (max-width: 768px) {
          .font40 {
            font-size: 28px;
          }

          .feature-box {
            padding: 20px;
          }
        }
      `}</style>
    </>
  );
}
